module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/products/products-create/products-create.component.css
// module id = ./src/app/views/products/products-create/products-create.component.css
// module chunks = main